/* global cituroWidget */
/* eslint no-undef: "error" */

export default function rlxOpenCituro() {
    const openCituroElements = Array.from(document.querySelectorAll('.js--show-cituro'));
    if (!openCituroElements.length) return;

    openCituroElements.forEach((openCituroLink) => {
        openCituroLink.addEventListener('click', (event) => {
            event.preventDefault();

            // brand, default is 'rolex'
            const brand = openCituroLink.getAttribute('data-cituro-brand') || 'rolex';
            let presetCategory = '11f0527ebdfc4a2fbf44e351c6e82575';
            if (brand !== 'rolex') {
                presetCategory = '11f16494ba7800a7ad3a4b8ba7c810b2';
            }
            cituroWidget.show({
                brand,
                presetCategory,
            });
        });
    });
}
